module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("copyright", [["span",{"class":"cp-dates"},[["textNode",{"text":" "}],["span",{},[],[["startDate","__text",true]]],["textNode",{"text":" - "}],["span",{},[],[["endDate","__text",true]]],["textNode",{"text":" "}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/publisher/templates/copyright.tpl
// module id = 142
// module chunks = 5